import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { IPagination } from "src/app/shared/models/pagination";
import { environment } from "src/environments/environment";
import ContractDTO from "../interfaces/ip-contract-dto";
import ContractPurchaseOrder from "../interfaces/ip-contract-purchase-order";
import ContractResponse from "../interfaces/ip-contract-response";
import ContractResponseOne from "../interfaces/ip-contract-response-one";
import { PageResponse } from "../interfaces/ip-page-response";
import { QueryParametersService } from "./ip-query-parameter.service";

@Injectable({
  providedIn: 'root',
})
export class IpActiveContractService {
  api = environment.api;

  constructor(
    private http: HttpClient,
    private queryParameterService: QueryParametersService,
  ) { }

  getData(
    pagination: IPagination,
    sortFieldName: string = 'creationDate',
    sortOrder: string = 'desc',
    searchName: string = '',
    searchValue: string = '',
  ): Observable<PageResponse<ContractResponse>> {
    const params = this.queryParameterService.buildQueryParameters(
      sortFieldName,
      sortOrder,
      pagination,
      searchName,
      searchValue,
    );
    return this.http.get<PageResponse<ContractResponse>>(
      `${this.api}/invopay/contracts`,
      { params }
    );
  }

  getContracts(): Observable<PageResponse<ContractResponse>> {
    return this.http.get<PageResponse<ContractResponse>>(
      `${this.api}/invopay/contracts`
    );
  }

  getContractById(id: number): Observable<ContractResponseOne> {
    return this.http.get<ContractResponseOne>(
      `${this.api}/invopay/contracts/${id}`
    );
  }

  createContract(request: ContractDTO): Observable<ContractDTO> {
    return this.http.post<ContractDTO>(
      `${this.api}/invopay/contracts`,
      request
    );
  }

  updateContract(id: number, request: ContractDTO): Observable<ContractDTO> {
    return this.http.put<ContractDTO>(
      `${this.api}/invopay/contracts/${id}`,
      request
    );
  }

  deleteContract(id: number): Observable<ContractDTO> {
    return this.http.delete<ContractDTO>(
      `${this.api}/invopay/contracts/${id}`
    );
  }

  getAvailableContracts(): Observable<Array<ContractPurchaseOrder>> {
    return this.http.get<Array<ContractPurchaseOrder>>(
      `${this.api}/invopay/contracts/available`
    );
  }

  getAvailableContractsBySupplierId(supplierId: number):
    Observable<Array<ContractPurchaseOrder>> {
    return this.http.get<Array<ContractPurchaseOrder>>(
      `${this.api}/invopay/contracts/available/${supplierId}`
    );
  }
}
